import type { Component } from 'solid-js'
import type { SongsTimeSeriesData } from '../../../features/engagement/domain/models/songs'
import { ChartContainer, ChartLegend, useChartWithLegend, useLegendState } from '../charts'
import {
  getSongsChartOptions,
  SONGS_LEGEND_ITEMS,
  SONGS_INITIAL_LEGEND_STATE,
  type SongsLegendState
} from './SongsChart.vm'

interface SongsChartProps {
  data: SongsTimeSeriesData[]
  showTimesPlayed?: boolean
  showUniqueListeners?: boolean
}

const SongsChart: Component<SongsChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const initialState: SongsLegendState = {
    timesPlayed: props.showTimesPlayed ?? SONGS_INITIAL_LEGEND_STATE.timesPlayed,
    uniqueListeners: props.showUniqueListeners ?? SONGS_INITIAL_LEGEND_STATE.uniqueListeners
  }

  const { state: legendState, toggle } = useLegendState(initialState)

  useChartWithLegend({
    data: () => props.data,
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getSongsChartOptions(data, legend)
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <ChartLegend items={SONGS_LEGEND_ITEMS} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default SongsChart
